<header class="main__content__header modal-header">
    <h2 class="modal-title">Detalhes da Solicitação</h2>
    <a class="header__btn__close" (click)="activeModal.close(true)">
        <span aria-hidden="true">X</span>
    </a>
</header>
<main class="modal-body">
    <!-- <h6>Dados Pessoais</h6>
    <section class="row content-details">         
        <div class="px-1 col-xl-4 col-lg-4">
            <span>Nome:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-4 col-lg-4">
            <span>Matrícula:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-4 col-lg-4">
            <span>CPF:</span>
            <span></span>
        </div>
    </section> -->
    <!-- <h6>Endereço</h6>
    <section class="row content-details">         
        <div class="px-1 col-xl-4 col-lg-4">
            <span>CEP:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-4 col-lg-4">
            <span>Endereço:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-4 col-lg-4">
            <span>Número:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-4 col-lg-4">
            <span>Complemento:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-4 col-lg-4">
            <span>Bairro:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-4 col-lg-4">
            <span>Caixa Postal:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-4 col-lg-4">
            <span>Município:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-2 col-lg-2">
            <span>UF:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-2 col-lg-2">
            <span>País:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-4 col-lg-4">
            <span>Telefone Celular:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-4 col-lg-4">
            <span>Telefone Comercial/Residêncial:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-6 col-lg-6">
            <span>País:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-6 col-lg-6">
            <span>E-mail:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-6 col-lg-6">
            <span>E-mail alternativo:</span>
            <span></span>
        </div>
    </section> -->
    <!-- <h6>Dados Bancários</h6>
    <section class="row content-details">         
        <div class="px-1 col-xl-6 col-lg-6">
            <span>Nome do Banco:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-6 col-lg-6">
            <span>Número da Conta:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-6 col-lg-6">
            <span>Tipo de Conta:</span>
            <span></span>
        </div>
        <div class="px-1 col-xl-6 col-lg-6">
            <span>Número da Agência:</span>
            <span></span>
        </div>
    </section> -->
    <h6>Status da Requisição</h6>
    <section class="row content-details">
        <div class="px-1 col-xl-6 col-lg-6">
            <span>Data de Solicitação:</span>
            <span>
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 10" />
                    <circle cx="10" cy="10" r="4" [attr.fill]="getRefundStatusColor(solicitacao?.statusId)" />
                </svg>
                {{ solicitacao.status.description }}
            </span>
        </div>
    </section>
    <h6>Instituto Escolhido</h6>
    <section class="row content-details">
        <div class="px-1 col-xl-6 col-lg-6">
            <span>Beneficio Solicitado:</span>
            <span>{{solicitacao.benefitType.description}}</span>
        </div>
        <div class="px-1 col-xl-6 col-lg-6">
            <span>Data de Solicitação:</span>
            <span>{{ solicitacao.solicitation.requestDate | date:'dd/MM/yyyy - HH:mm' }}</span>
        </div>
    </section>
    <h6>Dependentes de IR declarados</h6>
    <section class="row content-details">
        <ng-template #naoPossuiDependenteIr>
            <p class="content-aviso-template">
                Você não declarou dependente de IR!
            </p>
        </ng-template>
        <div class="content-revisao content-resultado-dependentes-ir"
            *ngIf="solicitacao && solicitacao.benefitDependant.length > 0 else naoPossuiDependenteIr">
            <p *ngFor="let dependente of solicitacao.benefitDependant">
                {{dependente.name}} - {{dependente.familyType}}
            </p>
        </div>
    </section>
    <section *ngIf="solicitacao.motivoRecusa">
        <h6>Conclusão</h6>
        <section class="row content-details">
            <div class="px-1 col-xl-6 col-lg-6">
                <span>Motivo:</span>
                <span>{{ solicitacao.motivoRecusa }}</span>
            </div>
        </section>
    </section>
    <!-- <h6>Instituto Escolhido</h6>
    <section class="row content-revisao content-card-revisao">
        <div class="px-1 col-xl-6 col-lg-6 row">
            <span>Instituto:</span>
            <span>
                <p *ngIf="formInstituido.get('instituido')?.value == 1">Aposentadoria </p>
                <p *ngIf="formInstituido.get('instituido')?.value == 10"> Autopatrocínio </p>
                <p *ngIf="formInstituido.get('instituido')?.value == 11"> Benefício Proporcional Diferido - (BPD) </p>
                <p *ngIf="formInstituido.get('instituido')?.value == 12"> Portabilidade Integral </p>
                <p *ngIf="formInstituido.get('instituido')?.value == 13"> Portabilidade Parcial </p>
                <p *ngIf="formInstituido.get('instituido')?.value == 14"> Resgate Integral </p>
                <p *ngIf="formInstituido.get('instituido')?.value == 15"> Resgate Parcial</p>
            </span>
        </div>
        <div class="px-1 col-xl-6 col-lg-6 row" *ngIf="formDocumentos.get('adicionalBeneficio')?.value != null">
            <span>Benefício:</span>
            <span>
                <p *ngIf="formDocumentos.get('adicionalBeneficio')?.value === 'true'">Com adicional de benefício de risco</p>
                <p *ngIf="formDocumentos.get('adicionalBeneficio')?.value === 'false'">Sem adicional de benefício de risco</p>
            </span>
        </div>
        <div class="px-1 col-xl-6 col-lg-6 row" *ngIf="possuiPeculio == true">
            <span>Permanecer com Plano Pecúlio:</span>
            <span>
                <p>Sim</p>
                <p>Não</p>
            </span>
        </div>
        <div class="px-1 col-xl-6 col-lg-6 row" *ngIf="formDocumentos.get('portabilidadeOuResgateParcial')?.value != null && formInstituido.get('instituido')?.value == 13">
            <span>Portabilidade Parcial:</span>
            <span>
                <p *ngIf="formDocumentos.get('portabilidadeOuResgateParcial')?.value == 'EAPC' ">Portabiliade Oriunda de EAPC</p>
                <p *ngIf="formDocumentos.get('portabilidadeOuResgateParcial')?.value == 'EFPC' ">Portabilidade oriunda de EFPC (Somente parte do participante)</p>
                <p *ngIf="formDocumentos.get('portabilidadeOuResgateParcial')?.value == 'FacultativasEOuAportes' ">Contribuições facultativas e/ou aportes</p>
            </span>
        </div>
        <div class="px-1 col-xl-6 col-lg-6 row" *ngIf="formDocumentos.get('quantidadeParcelas')?.value != null">
            <span>Forma de Pagamento:</span>
            <span>
                <p *ngIf="formDocumentos.get('quantidadeParcelas')?.value == '1' ">Parcela Única</p>
                <p *ngIf="formDocumentos.get('quantidadeParcelas')?.value != '1' ">Parcelado em {{formDocumentos.get('quantidadeParcelas')?.value}} vezes</p>
            </span>
        </div>
        <div class="px-1 col-xl-6 col-lg-6 row" *ngIf="formDocumentos.get('portabilidadeOuResgateParcial')?.value != null && formInstituido.get('instituido')?.value == 15">
            <span>Desejo Realizar o resgate parcial em:</span>
            <span>
                <p *ngIf="formDocumentos.get('portabilidadeOuResgateParcial')?.value == 'EAPC' ">Portabilidade oriunda de EAPC</p>
                <p *ngIf="formDocumentos.get('portabilidadeOuResgateParcial')?.value == 'EFPC' ">Portabilidade oriunda de EFPC</p>
                <p *ngIf="formDocumentos.get('portabilidadeOuResgateParcial')?.value == 'FacultativasEOuAportes' ">Contribuições facultativas e/ou aportes</p>
            </span>
        </div>
        <div class="px-1 col-xl-6 col-lg-6 row" *ngIf="formDocumentos.get('tributacao')?.value != null">
            <span>Tributação:</span>
            <span>
                <p *ngIf="formDocumentos.get('tributacao')?.value === 'Progressiva' ">Tributação pela tabela Progressiva</p>
                <p *ngIf="formDocumentos.get('tributacao')?.value == 'Regressiva' ">Tributação pela tabela Regressiva</p>                                
            </span>
        </div>
    </section> -->
</main>